export const DOCUMENTS_TABLE_NAME = 'DOCUMENTS_PAGINATED'
export const DOCUMENTS_QUERY_KEY = 'GetAllDocumentsPaginated'
export const AGREEMENT_DOCUMENTS_QUERY_KEY = 'agreementDocuments'
